import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";

interface SearchFieldProps {
  searchText: string;
  setSearchText: (_text: string) => void;
  placeholder?: string;
}
const SearchField: React.FC<SearchFieldProps> = ({ searchText, setSearchText, placeholder }) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Prevent certain keys from being handled by the Menu
    if (
      e.key === "ArrowUp" ||
      e.key === "ArrowDown" ||
      e.key === "Enter" ||
      e.key === "s" ||
      e.key === "S"
    ) {
      e.stopPropagation();
    }
  };
  return (
    <TextField
      variant="outlined"
      size="small"
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder || "Search"}
      fullWidth
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: (theme) => theme.palette.action.disabled }} />
            </InputAdornment>
          ),
          endAdornment: searchText && (
            <InputAdornment position="end">
              <IconButton onClick={() => setSearchText("")}>
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default SearchField;
